
<div class="agpr-bulkActionFormSentiment">
    <div
        id="bulkActionFormSentiment_label"
        class="agpr-bulkActionFormSentiment-label"
    >
        {{ 'Monitoring.bulk.action.setSentiment.inputLabel' | localize }}
        <span class="agpr-bulkActionFormSentiment-label-required" aria-hidden="true">*</span>
        <span class="u-srOnly"> {{ 'required' | localize }} </span>
    </div>
    <div class="agpr-bulkActionFormSentiment-options">
        <agpr-radio
            *ngFor="let sentiment of sentiments"
            class="agpr-bulkActionFormSentiment-option"
            [label]="sentiment.name"
            [value]="sentiment"
            [(ngModel)]="selectedSentiment"
            (ngModelChange)="changed()"
        >
        </agpr-radio>
    </div>
</div>
